export const bookingStatuses = {
  booked: 'booked',
  cancelledByUser: 'cancelled-by-user',
  cancelledByProvider: 'cancelled-by-provider',
};

export enum Privacy {
  private = 'private',
  unlisted = 'unlisted',
  public = 'public',
}

export enum ModerationStatus {
  pending = 'pending',
  approved = 'approved',
  rejected = 'rejected',
}

/**
 * Note the below values have to be url friendly, as we use them in the path for 3rd-party micro-service
 * For example:
 * - /3rd-party/coral/availability/{serviceId}
 * - /3rd-party/zeppelin/availability/{serviceId}
 */
export const providersEnglishNames = {
  please: 'please',
  zeppelin: 'zeppelin',
  zomato: 'zomato',
  coral: 'coral',
  leezair: 'leezair',
  yelp: 'yelp',
  custom: 'custom',
};

export const categoriesMap = {
  accommodation: 'Accommodation',
  activity: 'Activity',
  food: 'Food',
};

export enum PaymentGatewayName {
  stripe = 'stripe',
  paybear = 'paybear',
  coinbaseCommerce = 'coinbase-commerce',
  please = 'please',
}

export enum PaymentStatus {
  pending = 'pending',
  success = 'success',
  fail = 'fail',
}

export const paymentTypeMap = {
  fiat: 'fiat',
  crypto: 'crypto',
};

export const sortOrderMap = {
  asc: 1,
  desc: -1,
};

export enum PayAt {
  please = 'please',
  externalProvider = 'external-provider',
  destination = 'destination',
}

/**
 * Common Meal types that are provider agnostic
 */
export const mealTypeMap = {
  none: 'None',
  allFour: 'Breakfast, Brunch, Lunch & Dinner',
  allThree: 'Breakfast, Lunch & Dinner',
  lunchOrDinner: 'Breakfast & either Lunch or Dinner',
  breakfastOnly: 'Breakfast',
  allFourWithRoomService: 'Breakfast, Brunch, Lunch, Dinner and Room Service',
  selfCatering: 'Self Service Catering', // not sure what this is, just copied from Coral's documentation (https://storage.googleapis.com/cosmos-content/docs/index.html)
};

/**
 * Common Room types that are provider agnostic
 */
export const roomTypeMap = {
  single: 'Single bed',
  double: 'Double bed',
  twin: 'Twin bed',
  triple: 'One double and a single bed or some other combination of beds for 3',
  quad: '2 double beds or 1 double + 2 single beds or 4 single beds',
  five: 'Beds for 5 pax',
  six: 'Beds for 6 pax',
  seven: 'Beds for 7 pax',
  eight: 'Beds for 8 pax',
  family: 'Family Room', // not sure how many people can be accommodated, just copied from Coral's documentation
};

export enum TransportMode {
  car = 'car',
  walking = 'walking',
  bicycle = 'bicycle',
  publicTransit = 'public-transit',
}

export enum UserLevel {
  anonymous = 'anonymous',
  regular = 'regular',
  pro = 'pro',
}

export enum ReviewSide {
  posted = 'posted',
  received = 'received',
}

export const LAT_LNG_DECIMAL = 6;
export const MINUTES_IN_A_DAY = 1440;

/**
 * The Max number of tags on a service or trip
 */
export const MAX_NUMBER_OF_TAGS = 8;

/**
 * The Max number of notes in serviceOrg
 */
export const MAX_NUMBER_OF_NOTES = 10;

/**
 * 🚶‍♀️
 * 1 meter = 0.0508 calories
 */
export const WALKING_CALORIES_PER_METER = 0.0508;

/**
 * 🚴‍♂️
 * 1 meter = 0.02758895 calories
 */
export const BICYCLING_CALORIES_PER_METER = 0.02758895;

export enum RouteStatsUnit {
  calories = 'calories',
}

export const anonymousTokenPrefix = 'anonymous:';

export const peopleCountMatrix = [
  { adultCount: 1, childrenCount: 0, infantCount: 0 },
  { adultCount: 1, childrenCount: 1, infantCount: 0 },
  { adultCount: 2, childrenCount: 0, infantCount: 0 },
  { adultCount: 1, childrenCount: 2, infantCount: 0 },
  { adultCount: 2, childrenCount: 1, infantCount: 0 },
];

/**
 * The number of hours for which we should consider the availability fresh
 */
export const AVAILABILITY_LOGS_CACHE_HOURS = 3;

export const fallbackLanguage = 'en';
